import React from 'react'
import Popup from '../../../../../components/popup/Popup'
import Button from '../../../../../components/button/Button'
import SelectDropdown from '../../../../../components/dropdown/selectdropdown/SelectDropdown'
import styles from "../ManageFederalForms.styles"
import commonStyles from "../../ManageForms.styles"
import { BUTTON_TYPE } from '../../../../../components/button/constants'

const BlockSubmission = ({
    isPopupOpen,
    onCloseCb,
    selectedReferenceNumber = { label: "", value: "" },
    options = [],
    onSelectCb = () => { },
    onSubmitCb = () => { }
}) => {

    return (
        <>
            <Popup
                title={"Block Submission"}
                isPopupOpen={isPopupOpen}
                onCloseCb={onCloseCb}
                childrenStyles={styles.childrenStyles}
            >
                <p>Please select the reference number you want to block.</p>

                <div>
                    <SelectDropdown
                        label='Reference Number'
                        name="reference_number"
                        value={selectedReferenceNumber}
                        options={options}
                        dropdownMenuStyle={styles.dropdownMenu}
                        onSelectCb={onSelectCb}
                    />
                </div>

                <div style={styles.buttonsContainer}>
                    <Button style={commonStyles.button} onClickCb={onSubmitCb}>Submit</Button>
                    <Button
                        style={commonStyles.button}
                        type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}
                        onClickCb={onCloseCb}
                    >
                        Cancel
                    </Button>
                </div>
            </Popup>
        </>
    )
}

export default BlockSubmission;